let Emitter = require("./lib/Emitter");
let colors = require("./lib/Colors");
let keyboard = require("./lib/Keyboard");
let wait = require("./lib/Wait");

let Spinner = require("./widget/Spinner");
let Tooltip = require("./widget/Tooltip");
let Alert = require("./widget/Alert");
let Blast = require("./widget/Blast");
let Modal = require("./widget/Modal");

let LegalView = require("./view/LegalView");
let ErrorView = require("./view/ErrorView");
let HelpView = require("./view/HelpView");

let mounts = {};
let mount = function (id, insertBefore) {
  if (!mounts[id]) {
    let div = document.createElement("div");
    div.id = id;

    if (insertBefore) {
      mounts[id] = document.body.insertBefore(div, document.body.firstChild);
    }
    else {
      mounts[id] = document.body.appendChild(div);
    }
  }

  return mounts[id];
};

let _tooltip;
let _spinner;
let _alert;
let _blast;
let _modal;

let ui = new Emitter({
  // show or hide a "loading" indicator
  spin: function (n, message) {
    let component = <Spinner/>;
    _spinner = ReactDOM.render(component, mount("mc-spinner-mount"));
    _spinner.spin(n, message);
  },

  // show a custom alert
  alert: function (message, opts) {
    let component;
    let props = opts || {};

    if (!message) {
      if (_alert) {
        _alert.hide();
        _alert = null;
      }

      return;
    }

    component = <Alert {...props} message={message}/>;

    _alert = ReactDOM.render(component, mount("mc-alert-mount"));
    _alert.show();

    if (_tooltip) {
      _tooltip.hide();
    }
  },

  blast: function (message, opts) {
    let component;
    let props = opts || {};

    if (!message) {
      if (_blast) {
        _blast.hide();
        _blast = null;
      }

      return;
    }

    component = <Blast {...props} message={message}/>;

    _blast = ReactDOM.render(component, mount("mc-blast-mount", true));
  },

  // show a component instance in a modal window
  modal: function (instance, opts) {
    let component;
    let props = opts || {};

    if (!instance) {
      if (_modal) {
        _modal.hide();
        _modal = null;
      }

      return;
    }

    component = <Modal {...props}>{instance}</Modal>;

    _modal = ReactDOM.render(component, mount("mc-modal-mount"));
    _modal.show();

    if (_tooltip) {
      _tooltip.hide();
    }
  },

  fatal: function (message) {
     ReactDOM.render(<ErrorView message={message}/>, document.getElementById("mc-content"));
  },

  legal: function (path) {
    ui.modal(<LegalView path={path || "./legal/index.html"}/>);
  },

  help: function (path, width = "400px") {
    ui.modal(<HelpView path={path}/>, { width });
  },

  stat: function () {
    mc.ajax.get("/status").then(function (response) {
      let stat = mc.ajax.parse(response);

      mc.ui.alert("API version " + stat.version + " (" + stat.build + ")");
    }).catch(function (err) {
      mc.ui.alert("The API is unavailable.", { level: "error" });
    });
  },

  freeze: function (f) {
    document.body.style.overflow = f ? "hidden" : "scroll";
  },

  wait: wait,

  keyboard: keyboard,

  colors: colors
});

window.addEventListener("hashchange", function () {
  ui.modal(null);
  ui.alert(null);

  if (ui.tooltip) {
    ui.tooltip.hide();
    ui.emit("view");
  }
});

window.addEventListener("resize", function () {
  clearTimeout(ui._timeout);

  ui._timeout = setTimeout(function () {
    ui.emit("resize", window.innerWidth, window.innerHeight);
  }, 350);
});

window.addEventListener("DOMContentLoaded", function () {
  _tooltip = ReactDOM.render(<Tooltip/>, mount("mc-tooltip-mount"));

  // show or hide the tooltip
  ui.tooltip = {
    show: _tooltip.show,
    hide: _tooltip.hide
  };

  ui.emit("view");
});

document.addEventListener("visibilitychange", function () {
  if (document.hidden) {
    ui.emit("exit");
  }
  else {
    ui.emit("enter");
    ui.emit("view");
  }
});

module.exports = ui;
